module.exports = __webpack_public_path__ + "static/media/clubs_9.99964221.png";